module.exports = __webpack_public_path__ + "static/9-0286619703eb58593a73b523783fe0c7.png";